export default __webpack_public_path__ + "static/media/2214.62c04674.png";